import { ReactElement, useContext } from "react"

import { Datasets } from "../../../../../constants/enums"
import useUploadDeviceAttachments from "../../../../../services/middleware/hooks/devices/common/useUploadDeviceAttachments"
import useUploadedDeviceAttachments from "../../../../../services/middleware/hooks/devices/common/useUploadedDeviceAttachments"
import Attachments from "../../../common/components/attachments/attachments"
import { CreateV2GBundleContext } from "../providers/baseProviders/createV2GBundleProvider"

const EVACSupportingFiles = (): ReactElement => {
    const {
        currentIndex,
        setCurrentIndex,
        evacFormData,
        setEvacFormData,
        evacAttachmentUUID,
        createdEvacDeviceRef,
    } = useContext(CreateV2GBundleContext)

    const {
        uploadAttachments,
        error: uploadError,
        loading: attachmentUploadInProgress,
    } = useUploadDeviceAttachments(
        createdEvacDeviceRef,
        undefined,
        evacAttachmentUUID
    )

    const {
        uploadedAttachments,
        error: listAttachmentsError,
        isLoading: isLoadingUploadedAttachments,
        error: uploadedAttachmentsError,
        mutate: updateUploadedAttachments,
    } = useUploadedDeviceAttachments(
        Datasets.EVAC,
        createdEvacDeviceRef,
        evacAttachmentUUID,
        false
    )

    return (
        <Attachments
            isLct
            dataset={Datasets.EVAC}
            isAmendment={false}
            currentIndex={currentIndex}
            setCurrentIndex={setCurrentIndex}
            formData={evacFormData}
            setFormData={setEvacFormData}
            deviceRef={createdEvacDeviceRef}
            saveDraft={async () => undefined}
            saveDraftLoading={false}
            attachmentUUID={evacAttachmentUUID}
            uploadAttachments={uploadAttachments}
            attachmentUploadInProgress={attachmentUploadInProgress}
            uploadedAttachments={uploadedAttachments}
            isLoadingUploadedAttachments={isLoadingUploadedAttachments}
            uploadedAttachmentsError={uploadedAttachmentsError}
            updateUploadedAttachments={updateUploadedAttachments}
            listAttachmentsError={listAttachmentsError}
            uploadError={uploadError}
        />
    )
}

export default EVACSupportingFiles
